import { memo, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsAddedToSaved,
  showSavedTooltip,
} from "@/redux/savedpreference/savedPreferenceSlice";
import { getIsValidSearchName, onSaveSearch } from "@/api/savedSearch";
import { getParams } from "./searchParams";
import { setIsSaveSearch } from "@/redux/SRP/srpSlice";
import { trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";

function SaveSearchModal({ showModal, setShowModal, handleClose }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const srpInitData = useSelector((state) => state.srp.srpInitData);
  const properties = useSelector((state) => state.properties);
  const { searchBy, polygonId, polygonType } = useSelector(
    (state) => state.srp.srpInitData
  );

  const [searchName, setSearchName] = useState("");
  const [searchNameError, setSearchNameError] = useState("");

  const trackGAEvent = (eventName, details) => {
    trackButtonClick({
      eventName,
      eventSource: "Save Search Click",
      eventCategory: "NEW-SRP",
      eventLabel: `${details} | Location: ${getSrpLocationLabel()}`,
    });
  };

  useEffect(() => {
    if (searchBy && showModal) {
      setSearchName(searchBy);
      setSearchNameError('');
    }
  }, [searchBy, showModal]);

  const validateEmail = async () => {
    trackGAEvent("save_search_name_save_click", "Saved search Submit");

    var isValid = true;
    if (!searchName?.trim()) {
      setSearchNameError("Save Search name is required");
      isValid = false;
    }
    if (isValid) {
      setSearchNameError("");
      onSave();
    }
    return isValid;
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchName(value);
  };

  const onSave = async () => {
    const response = await getIsValidSearchName({ searchName });
    if (response?.data === true) {
      const searchResponse = await onSaveSearch({
        polygonId,
        polygonType,
        params: getParams({
          srpInitData,
          properties,
          searchName: searchName || srpInitData?.searchBy,
          pathname,
        }),
      });

      trackGAEvent("save_search_enabled", `Search Terms : STA:${srpInitData?.state}`);

      dispatch(
        setIsSaveSearch({
          isSearchSaved: true,
          searchId: searchResponse?.searchId,
        })
      );
      setShowModal(false);
      dispatch(setIsAddedToSaved());
      dispatch(showSavedTooltip(true));
    } else if (response?.errorCode === "SAVE_SEARCH_NAME_ALREADY_EXIST") {
      trackGAEvent("save_search_name_already_exists", "Save Search Exists");
      setSearchNameError(
        "This name already exists. Please select another name."
      );
    }
  };
  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Body>
        <div className="d-flex justify-content-between p10 pb0">
          <div className="d-flex">
            <div className="saveHead pt10">Save Search</div>
          </div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          ></button>
        </div>
        <div className="spss saveListing p20 pt0 pb0">
          <Row xs={12} md={12} className="d-flex align-items-start">
            <p className="save-popup-heading mb20">
              We'll notify you via email when properties are added that match
              your saved search.
            </p>
            <Col xs={8} md={8} className="d-flex align-items-start">
              <Row>
                <div className="searchLabel">
                  Name this Search <span className="asterisk">*</span>
                </div>
                <div className="d-flex p0">
                  <input
                    type="email"
                    className="form-control hubzu-text-box searchinput"
                    aria-label="email"
                    placeholder="Save Search Name"
                    value={searchName}
                    onChange={handleChange}
                    required
                  />
                </div>
                {searchNameError?.length > 0 && (
                  <span className="error-message pl0 pt20">{searchNameError}</span>
                )}
              </Row>
            </Col>
            <Col
              xs={4}
              md={4}
              className="smallFont d-flex align-items-start p0 mt20"
            >
              <button className="saveRegisterBtn ml20" onClick={validateEmail}>
                Save
              </button>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default memo(SaveSearchModal);
